import {Injectable} from '@angular/core';
import {AuthService} from "../core/authentication/auth.service";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { Urls, cityCenter} from '../../environments/environment';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class StartupService {
  public data;

  constructor(private http: HttpClient, private authService: AuthService) {
  }

  // This is the method you want to call at bootstrap
  // Important: It should return a Promise
  load(): Promise<any> {

    return this.http
      .get(Urls.scheduler_url + 'metadataprops/')
      .toPromise()
      .then((data: any) => {
        let startupData = data;
        if (startupData && startupData.data) {
          if (this.authService.agency && this.authService.agency.CITY) {
            let cityProps = startupData.data.filter((prop) => prop.city === this.authService.agency.CITY.toUpperCase());
            // firebaseConfig.databaseURL = cityProps[0].firebase_live_url;
            let cc = this.getCityCenter(cityProps[0].bound.lat1, cityProps[0].bound.lon1, cityProps[0].bound.lat2, cityProps[0].bound.lon2);
            cityCenter.lat = cc.lat;
            cityCenter.long = cc.long;
          }
        }
        Promise.resolve();
      })
      .catch((err: any) => {
        console.log(err);
        Promise.resolve();
      });
  }

  getCityCenter(lat1, lon1, lat2, lon2) {
    let dLon = this.toRadians(lon2 - lon1);

    //convert to radians
    lat1 = this.toRadians(lat1);
    lat2 = this.toRadians(lat2);
    lon1 = this.toRadians(lon1);

    let Bx = Math.cos(lat2) * Math.cos(dLon);
    let By = Math.cos(lat2) * Math.sin(dLon);
    let lat3 = Math.atan2(Math.sin(lat1) + Math.sin(lat2), Math.sqrt((Math.cos(lat1) + Bx) * (Math.cos(lat1) + Bx) + By * By));
    let lon3 = lon1 + Math.atan2(By, Math.cos(lat1) + Bx);
    return {lat: this.toDegrees(lat3), long: this.toDegrees(lon3)};
  }

  toRadians(degrees) {
    let pi = Math.PI;
    return degrees * (pi / 180);
  }

  toDegrees(radians) {
    let pi = Math.PI;
    return radians * (180 / pi);
  }
}
